import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  amount: 0,
  orderId: "",
  merchantName: "",
  expired_at: "",
  selected_method: "",
  paymentLink: null,
  paymentLinkHistory: null,
  paymentMethod: null,
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setInquiryDetails: (state, action) => {
      state.amount = action.payload.amount;
      state.orderId = action.payload.orderId;
      state.merchantName = action.payload.merchantName;
      state.expired_at = action.payload.expired_at;
      state.selected_method = action.payload.selected_method;
      state.paymentLink = action.payload.paymentLink || null;
      state.paymentLinkHistory = action.payload.paymentLinkHistory || null;
      state.paymentMethod = action.payload.paymentMethod || null;
    },
    clearInquiryDetails: (state) => {
      state.amount = 0;
      state.orderId = "";
      state.merchantName = "";
      state.expired_at = "";
      state.selected_method = "";
      state.paymentLink = null;
      state.paymentLinkHistory = null;
      state.paymentMethod = null;
    },
  },
});

export const { setInquiryDetails, clearInquiryDetails } = inquirySlice.actions;
export default inquirySlice.reducer;
